import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import PublicPageLayout from './PublicPageLayout';

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/public/contact', formData);
      setSubmitted(true);
      toast.success('Message sent!');
    } catch (err) {
      const message = typeof err.response?.data === 'string'
        ? err.response.data
        : 'Failed to send your message. Please try again.';
      setError(message);
      toast.error('Failed to send message');
    }
    setLoading(false);
  };

  return (
    <PublicPageLayout subtitle="Contact us" colProps={{ md: 6, lg: 5 }}>
      {submitted ? (
        <div className="text-center py-3">
          <i className="bi bi-check-circle text-success" style={{ fontSize: '2.5rem' }} />
          <p className="mt-3 mb-1">Thanks for reaching out!</p>
          <p className="text-muted small mb-4">We'll get back to you at {formData.email}.</p>
          <Link to="/">Back to home</Link>
        </div>
      ) : (
        <>
          <p className="text-muted small mb-4 text-center">
            Have a question, or something we should know before you sign up? Send us a
            message and we'll respond by email.
          </p>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="you@example.com"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={5000}
                placeholder="How can we help?"
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
              {loading ? 'Sending...' : 'Send message'}
            </Button>
          </Form>
        </>
      )}
    </PublicPageLayout>
  );
}

export default Contact;
